export type ChartType = keyof typeof ChartTypeEnum | string;

export const enum ChartTypeEnum {
  common = 'common',
  area = 'area',
  line = 'line',
  bar = 'bar',
  histogram = 'histogram',
  rangeColumn = 'rangeColumn',
  rangeArea = 'rangeArea',
  map = 'map',
  pie = 'pie',
  radar = 'radar',
  rose = 'rose',
  scatter = 'scatter',
  sequence = 'sequence',
  circularProgress = 'circularProgress',
  linearProgress = 'linearProgress',
  wordCloud = 'wordCloud',
  funnel = 'funnel',
  waterfall = 'waterfall',
  boxPlot = 'boxPlot',
  gauge = 'gauge',
  sankey = 'sankey',
  treemap = 'treemap',
  sunburst = 'sunburst',
  circlePacking = 'circlePacking',
  heatmap = 'heatmap',
  correlation = 'correlation',
  liquid = 'liquid',
  venn = 'venn',
  mosaic = 'mosaic'
}
